import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'hyperkit-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  standalone: true,
  imports: [CommonModule], // Import CommonModule for directives like ngClass
  changeDetection: ChangeDetectionStrategy.OnPush
  
})
export class MessageComponent {
  @Input() public type:
    | 'Neutral'
    | 'Success'
    | 'Warning'
    | 'Error'
    | 'Information' = 'Neutral';
  @Input() public text: string = '';
  @Input() public closable: boolean = false;
  @Input() public actionText?: string;

  public getIconClass(): string {
    switch (this.type) {
      case 'Success':
        return 'check';
      case 'Warning':
        return 'warning';
      case 'Error':
        return 'error';
      case 'Information':
        return 'info';
      default:
        return '';
    }
  }

  public onClose(): void {
    // Implement close functionality
  }

  public onAction(): void {
    // Implement action functionality
  }
}
